import _reduce from 'lodash/reduce'
import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import UserList from '../../components/UserList'
import localize from '../../store/localize'
import strings from '../../components/UserList/user-list.json'
import { actionUserSetOrder, actionUpdateAutoLaunchOnStartup } from '../../actions'
import { selectors as loadingBarSelectors } from '../../features/LoadingBar'

function getLoggedInUserList(users, server) {
    if (users.list == null || users.list[server] == null) return {}

    return _reduce(
        users.list[server],
        (r, v, k) => {
            if (v.shell === true) return r
            r[k] = v
            return r
        },
        {},
    )
}

function mapStateToProps(state) {
    const { app, servers, users, processes } = state
    const progress = loadingBarSelectors.getProgress(state)
    const server = servers.active
    const userList = getLoggedInUserList(users, server)
    const processList = processes[server]
    const userSortOrder = users.order[server]
    // todo: play -- this should listen to a single bool in state
    const playEnabled =
        // progress == null ||
        progress.percent === 0 || progress.percent === 100

    const autoLaunchOnStartup =
        app.autoRunEnabled &&
        selectors.getAutoLaunchOnStartup(state) &&
        // progress != null &&
        progress.percent === 100
    return {
        layout: selectors.getLayout(state),
        server,
        users: userList,
        processes: processList,
        sortList: userSortOrder,
        launchDelay: selectors.getLaunchDelay(state),
        playEnabled,
        autoLaunchOnStartup,
        updateLaunchOnStartup: () => actionUpdateAutoLaunchOnStartup(),
        localize: value => localize(strings, selectors.getLanguage(state), value),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setOrder: (server, order) => {
            dispatch(actionUserSetOrder(server, order))
        },
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        layout: stateProps.layout,
        server: stateProps.server,
        users: stateProps.users,
        processes: stateProps.processes,
        sortList: stateProps.sortList,
        launchDelay: stateProps.launchDelay,
        playEnabled: stateProps.playEnabled,
        localize: stateProps.localize,
        displayLoginWindow: ownProps.displayLoginWindow,
        autoLaunchOnStartup: stateProps.autoLaunchOnStartup,
        updateLaunchOnStartup: stateProps.updateLaunchOnStartup,
        setOrder: (order) => {
            dispatchProps.setOrder(stateProps.server, order)
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserList)



// WEBPACK FOOTER //
// ./src/containers/UserList/user-list.js